import { useMutation } from 'react-query'
import { POST_CLEAN_CACHE } from '@queries/keys'
import { postCleanCache } from '@queries/apis'
import { TResApi, TResApiErr } from '@configs/interface.config'
import { notification } from 'antd'
import { NError, NSuccess } from '@configs/const.config'

export * from './auth'
export * from './user'
export * from './role'
export * from './taxonomy'
export * from './media'
export * from './post'
export * from './game'
export * from './game-quiz'
export * from './game-comment'
export * from './notification'
export * from './option'
export * from './reward-user'
export * from './reward'
export * from './special-deal'
export * from './special-deal-user'
export * from './transaction'
export * from './account'
export * from './event'
export * from './analytics'

/**
 *
 * @method useMutationPostCleanCache
 */
export const useMutationPostCleanCache = () =>
  useMutation({
    mutationKey: [POST_CLEAN_CACHE],
    mutationFn: postCleanCache,
    onSuccess: (res: TResApi) => {
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      notification.error({ message: NError, description: error?.message })
    },
  })
